import {useState, useContext} from "react";
import {Link} from "react-router-dom";
import "../Styles/NavigationBarStyle.css"
import AuthContext  from "../contexts/AuthContext";
//import SideBar from "./SideBar";
//import LanguageSelector from "./LanguageSelector";

function NavigationBar() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const { logout} = useContext(AuthContext);



    const handleLogout = () => {
        setIsLoggedIn(false);
        //logout using autocontext
        logout();
        console.log("User logged out");
    };

    return (
        <header className="header-area header-sticky">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <nav className="main-nav">
                            {/* Logo */}
                            <Link className="logo" to="/home">
                                <img src="/images/logo.svg" alt="Logo"/>
                            </Link>

                            {/* Menu */}
                            <ul className={`nav ${menuOpen ? "active" : ""}`}>
                                <li className="has-sub">
                                    <Link to="/home">Ana Sayfa</Link>
                                </li>
                                    {/*   <ul className="sub-menu">
                                        <li><Link to="/home#courses">Hakkımızda</Link></li>
                                        <li><Link to="/home#our-facts">Kurslar</Link></li>
                                        <li><Link to="/home#contact">İletişim</Link></li>
                                    </ul>
                                </li>

                                <li className="has-sub">
                                    <Link to="/meetings">Meetings</Link>
                                    <ul className="sub-menu">
                                        <li><Link to="/upcoming-meetings">Upcoming Meetings</Link></li>
                                        <li><Link to="/meeting-details">Meeting Details</Link></li>
                                        <li><Link to="/meetings">All Meetings</Link></li>
                                    </ul>
                                </li>

                                <li><Link to="/contact">Contact Us</Link></li> */}
                                <li className="has-sub">
                                    <Link to="/about">Hakkımızda</Link>
                                    <ul className="sub-menu">
                                        <li><Link to="/about">Tarihçe</Link></li>
                                        <li><Link to="/our-mission">Misyonumuz</Link></li>
                                        <li><Link to="/our-vision">Vizyonumuz</Link></li>
                                        <li><Link to="/founder-message">Kurucumuzdan Mesaj</Link></li>
                                        {/*

                                        <li><Link to="/our-partners">Our Partners</Link></li>
                                        <li><Link to="/our-privacy-policy">Privacy Policy</Link></li>
                                        <li><Link to="/our-terms-and-conditions">Terms and Conditions</Link></li>
                                        <li><Link to="/our-legal-notice">Legal Notice</Link></li>
                                        <li><Link to="/our-cookies-policy">Cookies Policy</Link></li>
                                        <li><Link to="/our-complaints-policy">Complaints Policy</Link></li>*/}
                                    </ul>
                                </li>

                                <li className="has-sub">
                                    <Link to="/courses">Kurslar</Link>
                                </li>
                                {/*
                                <li className="has-sub">
                                    <Link to="/test">Test</Link>
                                    <ul className="sub-menu">
                                        <li><Link to="/test">Test</Link></li>
                                        <li><Link to="/video-test">Video Test</Link></li>
                                    </ul>
                                </li>
*/}
                                {/* Authentication */}
                                <li className="has-sub">
                                    {isLoggedIn ? (
                                        <Link to="/home" onClick={handleLogout}>Logout</Link>
                                    ) : (
                                        <Link to="/signin">Giriş Yap</Link>
                                    )}

                                    <ul className="sub-menu">
                                        <li><Link to="/signin">Kullanıcı Girişi</Link></li>
                                        <li><Link to="/signup">Kayıt Ol</Link></li>
                                        <li><Link to="/home" onClick={handleLogout}>Çıkış Yap</Link></li>
                                        {/*

                                        <li><Link to="/forgot-password">Forgot Password</Link></li>
                                        <li><Link to="/reset-password">Reset Password</Link></li>
                                        <li><Link to="/change-password">Change Password</Link></li>
                                        <li><Link to="/profile">Profile</Link></li>
                                        <li><Link to="/settings">Settings</Link></li>
                                        <li><Link to="/notifications">Notifications</Link></li>
                                        <li><Link to="/messages">Messages</Link></li>
                                        */}
                                    </ul>
                                </li>
                                {/* <li>
                                    <SideBar/>
                                </li>*/}
                            </ul>

                            {/* Mobile Menu Button */}
                            <a className="menu-trigger" onClick={() => setMenuOpen(!menuOpen)}>
                                <span>Menu</span>
                            </a>
                            {/* Language
                            <LanguageSelector/>
*/}

                            {/* Logo */}

                            <Link className="logo" to="/home">
                                <img src="/Logo2.png" alt="Logo" style={{width: "100px"}}/>
                            </Link>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default NavigationBar;
